import styled from "styled-components";

export const GamePopupCheckbox = styled.div<{checkboxChecked: boolean}>`
    width: 24px;
    height: 24px;
    float: right;
    background-image: url("${props => props.checkboxChecked ? props.theme.images.checkBoxChecked.toString() : props.theme.images.checkBoxEmpty.toString()}");
    background-repeat: no-repeat;
    align-self: center;
    margin-right: 10px;
`;